import {asset} from 'imba';
import url from './chart_pie.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M48 0H0V48H48V0ZM24 6L24 22.845L39.066 14.1466C35.8508 9.24051 30.3038 6 24 6ZM8.93368 33.8529L40.0676 15.8777C41.3036 18.3179 42 21.0776 42 24C42 33.9411 33.9411 42 24 42C17.696 42 12.1488 38.7593 8.93368 33.8529ZM24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})